import React from 'react';

const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Text with every occurrence of the search words wrapped in <mark>. */
const Highlight = ({ text, tokens }) => {
  const value = text === null || text === undefined ? '' : String(text);
  if (!tokens || !tokens.length || !value) return value;
  const pattern = new RegExp(`(${tokens.map(escapeRegExp).join('|')})`, 'gi');
  const parts = value.split(pattern);
  if (parts.length === 1) return value;
  return parts.map((part, idx) => (
    idx % 2 === 1 ? <mark key={idx} className="p-0">{part}</mark> : <React.Fragment key={idx}>{part}</React.Fragment>
  ));
};

export default Highlight;
